import { render, staticRenderFns } from "./PeriodForm.vue?vue&type=template&id=666614a5"
import script from "./PeriodForm.vue?vue&type=script&lang=js"
export * from "./PeriodForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports